import { COLOR } from '../types'

export const MINIMAL_COLORS: COLOR[] = [
  ['000000', 'Black'],
  ['0000FF', 'Blue'],
  ['00FF00', 'Green'],
  ['00FFFF', 'Cyan / Aqua'],
  ['315BA1', 'Azure'],
  ['370202', 'Chocolate'],
  ['483C32', 'Taupe'],
  ['4F69C6', 'Indigo'],
  ['660099', 'Purple'],
  ['706555', 'Coffee'],
  ['888D65', 'Avocado'],
  ['967BB6', 'Lavender Purple'],
  ['A9C6C2', 'Opal'],
  ['AF8F2C', 'Alpine'],
  ['DA3287', 'Cerise'],
  ['EB9373', 'Apricot'],
  ['ED9121', 'Carrot Orange'],
  ['F5F5DC', 'Beige'],
  ['FDE910', 'Lemon'],
  ['FF0000', 'Red'],
  ['FF007F', 'Rose'],
  ['FF00FF', 'Magenta / Fuchsia'],
  ['FF681F', 'Orange'],
  ['FF69B4', 'Hot Pink'],
  ['FF7F50', 'Coral'],
  ['FF8C69', 'Salmon'],
  ['FFC0CB', 'Pink'],
  ['FFDB58', 'Mustard'],
  ['FFDDAF', 'Caramel'],
  ['FFE5B4', 'Peach'],
  ['FFFDD0', 'Cream'],
  ['FFFF00', 'Yellow'],
  ['FFFFF0', 'Ivory'],
  ['FFFFFF', 'White']
]
